import styled from 'styled-components'

interface IAccordionStyles {
  isOpen: boolean
}

export const TimelineAccordionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

export const TimelineAccordionTitle = styled.button<IAccordionStyles>`
  padding: 3px 3px 3px 5px;
  width: min-content;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;

  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  background: transparent;
  transition: background-color 100ms ease-in-out;

  font-size: 14px;
  line-height: 17px;
  font-weight: 700;

  color: ${props => props.theme.colors.color005597};

  svg {
    transform: translateY(-1px) ${props => (props.isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
    fill: ${props => props.theme.colors.color545e6c};
    width: 7px;

    g {
      clip-path: none;
    }
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  &:active {
    background: rgba(0, 0, 0, 0.15);
  }
  &:focus-visible {
    border: 1px solid rgba(0, 0, 0, 0.3);
    outline: none;
  }
`

export const TimelineAccordionContent = styled.div<IAccordionStyles>`
  position: relative;
  height: ${props => (props.isOpen ? '100%' : '0')};
  transition: height 300ms ease-in-out;

  animation: ${props => (props.isOpen ? 'collapse' : 'expand')} 0s ease-in-out;
  animation-delay: 300ms;
  overflow: ${props => (props.isOpen ? 'visible' : 'hidden')};

  @keyframes collapse {
    0% {
      max-height: 100%;
      opacity: 1;
    }
    100% {
      max-height: 0px;
      opacity: 0;
    }
  }
  @keyframes expand {
    0% {
      max-height: 0px;
      opacity: 0;
    }
    100% {
      max-height: 100%;
      opacity: 1;
    }
  }
`
